(function () {
  'use strict';
  if (customElements.get('nh-collection-comparison')) return;
  customElements.define('nh-collection-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      let previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (!previewId && window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'unpublished') {
        previewId = String(window.Shopify.theme.id);
      }
      if (previewId) {
        this.querySelectorAll('[data-nh-compare-model]').forEach(link => {
          const destination = new URL(link.href, window.location.origin);
          destination.searchParams.set('preview_theme_id', previewId);
          link.href = destination.pathname + destination.search;
        });
      }
      if (window.matchMedia('(max-width: 1100px)').matches) {
        requestAnimationFrame(() => {
          const cards = this.querySelector('.nh-compare__cards');
          const current = this.querySelector('[data-nh-current-model]');
          if (cards && current && cards.scrollLeft === 0) {
            cards.scrollLeft = current.offsetLeft - cards.offsetLeft;
          }
        });
      }
      if (!this.querySelector('[data-nh-construction]') || !window.HTMLDialogElement) return;
      const trigger = this.querySelector('[data-nh-open]');
      const construction = this.querySelector('[data-nh-construction]');
      const dialog = this.dialog || document.createElement('dialog');
      this.dialog = dialog;
      dialog.className = 'nh-compare__dialog';
      dialog.setAttribute('aria-labelledby', construction.querySelector('h2').id);
      if (!dialog.parentNode) { construction.before(dialog); dialog.append(construction); }
      trigger.setAttribute('aria-haspopup', 'dialog');
      this.querySelector('[data-nh-close]').hidden = false;
      trigger.addEventListener('click', event => { event.preventDefault(); dialog.showModal(); this.querySelector('[data-nh-close]').focus(); }, options);
      this.querySelector('[data-nh-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus(); }, options);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
  });
})();
